// extracted by mini-css-extract-plugin
module.exports = {"error":"Recaptcha__error__kUtC1"};